/* 20241103: xt - this was copied from Reports component and modified for the Map Tab component
// need to remove the table codes or any other unnecessary code... later...s
// 20241111: added code to print only the map container area..used the useEffect hook
//         also noticed that the handleCsv prop that is a function,is really fetch the points not make the table yet
//         now need to fix the Previous/back button to correctly map the markers..
//          so also 'handlePrev" is a function passed as a prop
//      try to fix error in map.js
//  20250626: update for react-bootstrap v2 (too hard to do B5 only all at once so later)
// 20250721: NOTE; GK USED 'ID' TO MEAN DIFFERENT THINGS THROUGHOUT THIS CODE.. NEED TO FIX THAT!!
// 20250721:  fixed the id issue, fixed using the real source of truth for ageny
//            fixed the errors in .map code missing the key={} all runs without errors in console
** 
*/

import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
//import {  Button, Dropdown } from "react-bootstrap";
import { FormattedDate, FormattedTime, IntlProvider } from "react-intl";
// import Dropdown from "react-bootstrap/lib/Dropdown";
// import DropdownToggle from "react-bootstrap/lib/DropdownToggle";
// import DropdownMenu from "react-bootstrap/lib/DropdownMenu";
import Select from "react-select";
// xt please leave this space. it reminds me that I want 'moment' taken out at some point
import moment from "moment";
// xt leave space
//import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
//import BootstrapTable from 'react-bootstrap-table-next';
//import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
//import "react-bootstrap-table2/dist/react-bootstrap-table2.min.css";
//import "react-table/react-table.css";
import "./MapTab.css";
import moments from "moment-timezone";
import { CSVLink } from "react-csv"; // xt NOTE: the CSVLink is being used to create the download csv file
import { languageLabel } from "../../utils/Languages";
import DatePicker from "react-datepicker";
import { Modal } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams, useLocation } from 'react-router-dom';

import AgencySelector from '../../components/AgencySelector/AgencySelector';
//import Map from '../Map/Map';
import MapNewGoogle from "../MapNewGoogle/MapNewGoogle";

const MapTab = ({
  dispatch,
  reports,
  agency,
  languageCode,
  profile,
  checkboxvalue,
  handleCheckBox,
  handleStatusCheckBox,
  startDate,
  endDate,
  handleStart,
  handleEnd,
  prepareFetch,
  page,
  totalPage,
  updatePageRow,
  handlePageRow,
  handlePageSize,
  handleNext,
  handlePrev, // xt this is prev button function.. and uses prepare fetch
  isFetching,
  handleCsv, // xt this is really a function to fetch the incidents w/ a limit of 500 per fetch. The name is BAD choice
  reportCSV,
  handleclearAll,
  checkboxStatusvalue,
  handleCheckBoxLanguage,
  checkboxLanguagevalue,
  isFetchingcsv,
  //handleExportModalClose,
  en_count,
  es_count,
  count,
  showLimitModal,
  inc_types,
  timezones,
  timezone,
  handleTimezone,
  //match, //this was old RR5 object not used in RR^
  /*New code added by GK 09-15-2023 start - will be updated by updateWindowDimensions in state*/
  height,
  /*New code added by GK 09-15-2023 end*/
}) => {
  var data = [];
  var headers = [];
  let csvData = reportCSV;
  //const { id } = useParams(); // not sure this is needed --added for RR6 to get the id it used to use match
console.log("inc_types ", inc_types);
console.log('maptab timezones should be array ', timezones);

// xt from chatgpt to print map
const handlePrint = () => {
  setTimeout(() => {
    window.print();
  }, 100);
  };

// xt from chaggpt but I modified
// xt can we clean up the page and put a better title on it??
// Using useEffect to add styles to the head I changed to the center-block-container
// so the printer IS respecting the "width" in #printable-map but NOT the height?
useEffect(() => {
  const styleTag = document.createElement('style');
  styleTag.innerHTML = `
    @media print {
      body * {
        visibility: hidden;
      }
      #printable-map, #printable-map * {
         visibility: visible;
      }
      #printable-map {
      position: absolute;
      left: 0;
      top: 50px;
      width: 1500px;  /* xt this DOES seem to have an effect on the printed map */
      height: 900px; /* xt this seems to have no effect on the height of the printed map */
      }
      .print-title {
      visibility: visible;
      top: 0;
      left: 0;
      right: 0;
      background-color: white;
      z-index: 1000; /* Ensure it's on top */
      padding: 10px 0; /* Add padding on top and bottom for a little spacen above and below the text */
      }
      /* xt this section sets the alignment of the title on the print page */
      .print-title, h2 {
      text-align: left !important;
      margin: 480px;
      
      }
      .map-container {
      position: absolute;
      top: 50px; /* Adjust based on title height */
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
      height: 1000px; /* xt this was added but has no effect on the printed map */
    }
    }
  `;
  document.head.appendChild(styleTag);

  // Clean up the style tag on component unmount
  return () => {
    document.head.removeChild(styleTag);
  };
}, []);  // Empty dependency array means this effect runs only once (on mount)

/// end chat... but prints blank page except for title
  // Regular expression pattern to match epoc dates in 10 to 12 digit format
  const dateRegex = /\b\d{10,13}\b/g;
  // try to make a regex to match the unix epoc time string.?
  const stringRegex = /\d{13}/g; // xt i am trying to see if we can match the 13 digit string of epoch

  /**
   * @author Sultan
   * 03-03-2023
   * get csv data and date formated.
   */
  const csvdata = csvData.map((i) => {
    return {
      ...i,
      ...{
        start: timezone
          ? moments(timezoneformatDate(i.start))
              .tz(timezone)
              .format("MM/DD/YY HH:mm")
          : epocToUTCDefault(i.start),
      },
      ...{
        received: timezone
          ? moments(timezoneformatDate(i.received))
              .tz(timezone)
              .format("MM/DD/YY HH:mm")
          : epocToUTCDefault(i.received),
      },
      ...{
        occurred: timezone
          ? moments(timezoneformatDate(i.occurred))
              .tz(timezone)
              .format("MM/DD/YY HH:mm")
          : epocToUTCDefault(i.occurred),
      },
      ...{
        sent: timezone
          ? moments(timezoneformatDate(i.sent))
              .tz(timezone)
              .format("MM/DD/YY HH:mm")
          : epocToUTCDefault(i.sent),
      },
      ...{
        messages: timezone
          ? messagesToTimezone(i.messages, timezone)
          : messagesToTimezone(i.messages, "default"),
      },
      ...{
        internal: timezone
          ? messagesToTimezone(i.internal, timezone)
          : messagesToTimezone(i.internal, "default"),
      },
    };
  });

  function formatDate(cell) {
    // return moment(cell).format("YYYY-MM-DD HH:MM");
    return moment(cell).format("MM/DD/YY HH:mm");
  }

  function timezoneformatDate(cell) {
    // return moment(cell).format("YYYY-MM-DD HH:MM");
    return moment(cell).format("MM/DD/YY HH:mm");
  }

  /**
   *@author Sultan
   * @param {*} text
   * @param {*} timezone
   * @returns
   * @description Converts the string of the date message to the required time zone
   * date
   *  17 July 2023
   * messagesToTimezone
   * timezoneformatDateObject
   * timezoneformatDateString
   */
  function messagesToTimezone(text, timezone) {
    let isFirstLine = true;
    let convertedText = text.replace(dateRegex, (match) => {
      //New code added by GK 26-07-2023
      if (timezone !== "default") {
         let date = epocToUTC(match);
         let d2 = moments
           .tz(date, "MM/DD/YY HH:mm", timezone)
           .format("MM/DD/YY HH:mm");
         if (isFirstLine) {
           isFirstLine = false;
           return d2; // First line doesn't have "\r\n"
         } else {
           return "<br>" + d2; // Add "\r\n"  before other lines
         }
       } else {
         if (isFirstLine) {
           isFirstLine = false;
           return epocToUTCDefault(match); // First line doesn't have "\r\n"
         } else {
           return "<br>" + epocToUTCDefault(match);
           // Add "\r\n"  before other lines
         }
       }
    });
    return convertedText;
  }

  /* //Commented by GK 26-07-2023
    function epocToUTCDefault(cell) {
      let date = moment.utc(+cell).format("MM/DD/YY HH:mm");
      return date;
    }*/
  //New code added by GK 26-07-2023
  function epocToUTCDefaultRes(cell) {
    let currenttimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let date = moments(timezoneformatDate(cell))
      .tz(currenttimezone)
      .format("MM/DD/YY HH:mm");
    return date;
  }

  function epocToUTC(cell) {
    let date = moment.utc(+cell).toDate();
    return date;
  }

  function epocToUTCDefault(cell) {
    //Commented by GK 26-07-2023
    /* let date = moment.utc(+cell).format("MM/DD/YY HH:mm");
      return date; */
    //New code added by GK 26-07-2023
    let currenttimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let date = moments(timezoneformatDate(Number(cell)))
      .tz(currenttimezone)
      .format("MM/DD/YY HH:mm");
    return date;
  }

  // add dateFormatter component. it will convert unix data formate to mm-dd-yyy HH:MM Formated
  function startDateFormatter(cell, row) {
    return (
      <IntlProvider locale="en">
        <div>
          <FormattedDate
            value={cell}
            month="numeric"
            day="numeric"
            year="2-digit"
          />{" "}
          <FormattedTime value={cell} hour12={false} />
        </div>
      </IntlProvider>
    );
  }
  /**
   * @author Sultan Mirza
   * 03-03-2023
   *  added new header as photos_url
   * .
   */
// sultan had a header here..dont konw if it is needed for just the filter
  var types = {};
  var stats = {};
  var languages = {};
  //let data =[];
   //data = reports;

  for (let i = 0; i < reports.length; i++) {
    let e = reports[i];

    if (types[e.type] == undefined) {
      types[e.type] = e.type;
    }

    if (stats[e.status] == undefined) {
      stats[e.status] = e.status;
    }

    const language_label = languageLabel(e.user_language);
    languages[language_label] = (languages[language_label] || 0) + 1;

    var desc = e.description;
    if (desc != undefined) {
      e.description = desc.replace(/["']/g, ""); // xt not sure what this is doing. Needs a comment Sultan.  if undefined it is set to [] ?
    }

    var mess = e.messages;
    if (mess != undefined) {
      e.messages = mess.replace(/["']/g, ""); // xt again how is replacing ["'] grabbing [] ?
    }
    const reportSchema = agency.details.report_schemas
      ? agency.details.report_schemas.find(
          (schema) => schema._id === e.report_schema_id
        )
      : [];

    // Get report states for dashboard only
    let reportStates = [];
    let reportStatuses = [];
    let selectedStatus = {};
    let selectedState = {};
    if (undefined !== reportSchema) {
      reportStates = reportSchema.report_states;
      // ? reportSchema.report_states.filter(state => state.types.find(type => type === 'dashboard'))
      // : []

      reportStatuses = reportSchema.report_statuses;
      // Get selected state and status
      selectedState =
        e.state && reportSchema.report_states
          ? reportSchema.report_states.find((state) => state._id === e.state)
          : {};
      selectedStatus =
        selectedState && reportStatuses
          ? reportStatuses.find(
              (status) => status._id === selectedState.report_status_id
            )
          : {};
    }
    e.status = "Closed";

    /* if (selectedStatus.title !== undefined) {
        if (selectedStatus.title[languageCode] !== undefined) {
          e.status = selectedStatus.title[languageCode];
        }
      } */
    reports[i].status = e.status;
    var row = {
      incident_number: e.incident_number,
      type: e.type,
      user_language: languageLabel(e.user_language),
      status: e.status,
      start: timezone
        ? moments(timezoneformatDate(e.start))
            .tz(timezone)
            .format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.start), //Commented by GK 26-07-2023 epocToUTCDefault(e.start)
      occurred: timezone
        ? moments(timezoneformatDate(e.occurred))
            .tz(timezone)
            .format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.occurred), //Commented by GK 26-07-2023 epocToUTCDefault(e.occurred)
      received: timezone
        ? moments(timezoneformatDate(e.received))
            .tz(timezone)
            .format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.received), //Commented by GK 26-07-2023 epocToUTCDefault(e.received)
      sent: timezone
        ? moments(timezoneformatDate(e.sent))
            .tz(timezone)
            .format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.sent), //Commented by GK 26-07-2023 epocToUTCDefault(e.sent)
      description: e.description,
      gps: e.gps,
      num_photos: e.num_photos,
      // num_photos: e.num_photos == "" ? 0 : e.num_photos.split(",").length,
      photos_url: e.photos_url
        .replace(/"/g, "")
        .split(",")
        .map((link) => {
          return link;
        }),

      location: e.location,
      address: "N/A",
      reporter_name: e.reporter_name,
      reporter_email: e.reporter_email,
      reporter_phone: e.reporter_phone,
      messages: timezone
        ? messagesToTimezone(e.messages, timezone)
        : messagesToTimezone(e.messages, "default"),
      internal: timezone
        ? messagesToTimezone(e.internal, timezone)
        : messagesToTimezone(e.internal, "default"),
      ack_time: e.ack_time,
    };


    data.push(row); // createing table of data
  }

  var languages_stats = {};
  for (let language in languages) {
    languages_stats[language] = language + ` (${languages[language]})`;
  }
  var file_name = "bsg_report_export_" + moment().format("YYYY_MM_DD") + ".csv";
  const tableOptions = {
    defaultSortName: "incident_number",
    defaultSortOrder: "desc",
  };

  // xt no clue if this should go here..
  // xt setup the coord items to pin map on map.. 
  let coordinatePoints = [] // xt setup empty array to hold points to pin map
  let centerPoint = {} // xt the new google map uses a center obj and does not use the [0] anymore
      centerPoint = {
       lat: agency.details.map_center.latitude,
       lng: agency.details.map_center.longitude,
      }

  //xt need to get the coordinates info from each report (coord) that Map will use to pin map the points
   reports.map((data) => coordinatePoints.push({
    coordinates: {
      lat: Number(data.gps.replace(/Lat:|Long:/g, '').split(',')[0].trim()),
      lng: Number(data.gps.replace(/Lat:|Long:/g, '').split(',')[1].trim()),
      color: "1c1e5f", // xt blue
    }, 
    color: data.report_status_id == "62d000000000000000000101" ? "#FF0000" : data.report_status_id == "62d000000000000000000102" ? "#00FF00" : data.report_status_id == "62d000000000000000000103" ? "#0000FF" : "1c1e5f",
    report_name : agency.details.report_name.en_US,
    communications : data.messages,
    location : data.location,
    type : data.type, // like drug abuse or late bus...etc
    //typeOffset : data.inc_types.indexOf(data.type),
    data: data,
    data_inc_types: inc_types,
    typeOffset: (data && inc_types 
      ? inc_types.indexOf(data.type) 
      : -1), // xt now I get the offset of the type array.. then I should get a color from a color array
    received: data.received,
    occurred: data.occurred,
    incident_number: data.incident_number,
  }))
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            fontSize: "18px",
            marginLeft: "10px",
            fontWeight: "bold",
          }}
        >
          Total: {""} {count}
        </span>
        {/**
         * @author Sultan
         * 03-03-2023
         * export all data UI and function call.
         */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {/* <button className="exportData-button" onClick={() => handleCsv()}> */}
          <button className="exportData-button" onClick={() => handlePrint()}>
            {isFetchingcsv === "fetching print data" ? "loading..." : "Print Map Screen "}
          </button>
        </div>
      </div>

      <div className="main-block-b">
        <div className="sidebar">
          <div style={{ width: '20%', minWidth: '250px' }}>
            <div style={{ width: "100%" }}>
              Timezones:
              {/* <Select
                name="form-field-name"
                clearable={false}
                value={timezone}
                onChange={(e) => handleTimezone(e)}
                options={["Select timezone", ...timezones].map((timezone) => ({
                  value: timezone,
                  label: timezone,
                }))}
              /> */}
              <select
                className="form-select"
                value={timezone}
                onChange={(e) => handleTimezone(e.target.value)}
              >
                <option disabled>Select timezone</option>
                {timezones.map((tz) => (
                  <option key={tz} value={tz}>
                    {tz}
                  </option>
                ))}
              </select>

            </div>
          </div>
          <div className="sidebar-top-block">
            <span className="top-filter-heading">Filters</span>
            <span
  onClick={() => handleclearAll()}
  style={{
    display: "inline-block",
    padding: "6px 12px",
    backgroundColor: "#dc3545", // Bootstrap "danger" red
    color: "#fff",
    border: "1px solid #fff",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "0.875rem",
    textAlign: "center"
  }}
>
  Clear All
</span>
          </div>
          <div className="sidebar-item-block">
            {/**
             * @author Sultan
             * 03-03-2023
             * Filter by date.
             */}
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">{`Date`}</span>
              </div>

              <div
                className="datepicker-output"
                style={{
                  color: "black",
                }}
              >
                <div
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <DatePicker
                    id="startDate11"
                    selected={startDate}
                    onChange={handleStart}
                    placeholderText="Start Date"
                    className="start-datepicker"
                  />
                </div>
                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <DatePicker
                    id="endDate11"
                    selected={endDate}
                    onChange={handleEnd}
                    placeholderText="End Date"
                    className="end-datepicker"
                  />
                </div>
              </div>

              <div className="btn-output" style={{ margin: "20px 0px" }}>
          <button
            type="button"
            className="btn btn-primary filter-btn"
           onClick={prepareFetch}
           >
            Submit
         </button>
      </div>

            </div>
            {/**
             * @author Sultan
             * 03-03-2023
             * create User language  checkbox UI.
             * onChange handleCheckBoxLanguage function is called and store the user language value
             */}
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">{`User language`}</span>
              </div>
              {["en_US", "es_US"].map((language) => (
                <div  key={language} className="item-filter-content-b">
                  <input
                    type={"checkbox"}
                    id={`lang-${language}`}
                    style={{ marginRight: "10px" }}
                    onChange={(e) => handleCheckBoxLanguage(e)}
                    value={language}
                    checked={
                      checkboxLanguagevalue.filter((i) => i === language)
                        .length > 0
                        ? true
                        : false
                    }
                  />
                  <label htmlFor={`lang-${language}`} className="label-item">
                    {`${language === "en_US" ? "English" : "Spanish"}(${language === "en_US" ? `${en_count}` : `${es_count}`
                      })`}
                  </label>
                  <br />
                </div>
              ))}
            </div>
            {/**
             * @author Sultan
             * 03-03-2023
             * create status checkvbox UI.
             * checkboxStatusvalue is filtering the value and if match then update checked true
             */}
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">Status</span>
              </div>
              {["new", "open", "closed"].map((statusType) => (
                <div className="item-filter-content-b" key={statusType}>
                  <input
                    type={"checkbox"}
                    id={`status-${statusType}`}
                    //id="1b"
                    style={{ marginRight: "10px" }}
                    onChange={(e) => handleStatusCheckBox(e)}
                    value={statusType}
                    checked={
                      checkboxStatusvalue.filter((i) => i === statusType).length > 0
                        ? true
                        : false
                    }
                  />
                  <label htmlFor={`status-${statusType}`} className="label-item">
                    {" "}
                    {statusType.toLocaleUpperCase()}
                  </label>
                  <br />
                </div>
              ))}
            </div>
            {/**
             * @author Sultan
             * 03-03-2023
             * create incident type checkvbox UI.
             * checkboxvalue is filtering the value if match found then checked true
             */}
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">Incident Type</span>
              </div>
              {inc_types.map((incidentType) => (
                <div key={incidentType} className="item-filter-content-b">
                  <input
                    type={"checkbox"}
                    id={`type-${incidentType}`}
                    //id="1b"
                    style={{ marginRight: "10px" }}
                    onChange={(e) => handleCheckBox(e)}
                    value={incidentType}
                    checked={
                      checkboxvalue.filter((i) => i === incidentType).length > 0
                        ? true
                        : false
                    }
                  />
                  <label htmlFor={`type-${incidentType}`} className="label-item">
                    {/* //<label htmlFor="1b" className="label-item"> */}
                    {incidentType}
                  </label>
                  <br />
                </div>
              ))}
            </div>

          </div>
        </div>
          {/* THIS IS THE CENTER OF THE MAP AREA */}
        <div style={{ display: "flex", width: "80%", flexDirection: "column" }}>
          {/**
           * @author Sultan
           * 03-03-2023
           * added loader
           * if isFetching is true then loader show  loading
           */}
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <ClipLoader
              cssOverride={{
                position: "absolute",
                top: "300px",
                left: "auto",
                right: "auto",
                zIndex: "99999",
              }}
              size={50}
              color="black"
              loading={isFetching}
            />
          </div>
          <div
            className="center-block-div"
            style={{
              height: height,
              overflow: "auto",
            }}
          >
            {/*New code above added by GK 09-15-2023 ends here. the next section is where the table was and I changed to the map*/}

            <div className="center-block-container" id="printable-map">
              <h2 style={{ marginTop: "3px", textAlign: "center", padding: "2px 0" }} className="fs-4 print-title" >Map of Incidents</h2>
              <div className="map-container">
                {/* <AgencySelector pathRef='/maptabview' id={id} > */}
                  {/* <Map coords={coordinatePoints} agency={agency} languageCode={languageCode} /> */}
                  {/* <MapNewGoogle coords={coordinatePoints} center={centerPoint} agency={agency} /> */}
                    <MapNewGoogle coords={coordinatePoints} center={centerPoint} />
                {/* </AgencySelector> */}
              </div>
            </div>
          </div>
          <div className="center-block-pagination-container">
            {data.length > 0 && (
              <div
                style={{
                  width: "80%",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  marginTop: "20px",
                  marginBottom: "30px",
                }}
              >
                <div
                  className="next-prev-div bg-prev"
                  onClick={() => handlePrev(page)}
                >
                  Previous
                </div>
                <div className="page-count-div">
                  <span>Page</span>
                  <input
                    className="input-page"
                    value={page}
                    onChange={(e) => handlePageSize(e)}
                  />
                  <span>of</span>
                  <span>{totalPage}</span>
                </div>
                <div>
                  <div className="dropdown dropup">
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownRows"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {updatePageRow}
                    </button>
                    <ul
                      className="dropdown-menu text-center"
                      aria-labelledby="dropdownRows"
                      style={{ minWidth: "70px" }}
                    >
                      {[10, 20, 30, 50].map((i) => (
                        <li key={i}>
                          <button
                            className="dropdown-item"
                            style={{ border: "none", borderRadius: "0px", width: "100%" }}
                            type="button"
                            onClick={() => handlePageRow(i)}
                          >
                            {i}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  className="next-prev-div bg-next"
                  onClick={() => handleNext(page)}
                >
                  Next
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/**
       * @author Sultan
       * 03-03-2023
       * Export data download Modal.
       * if showLimitModal andd isFetchingcsv value is false then modal will not open
       * handleExportModalClose function close the modal
       */}

      {/* <Modal
        show={
          isFetchingcsv === "receive_data_success" || showLimitModal
            ? true
            : false
        }
        onHide={handleExportModalClose}
        aria-labelledby="example-custom-modal-styling-title"
        style={{
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "100px",
          height: "100%",
        }}
        size="sm"
      >
        <Modal.Header>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Modal.Title id="example-custom-modal-styling-title">
              Print Map
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "120px",
            width: "100%",
          }}
        >
          <div className="text-center" style={{ marginTop: "20px" }}>
            {isFetchingcsv === "receive_data_success" && (
              <CSVLink
              data={csvdata.slice(-500)}
                headers={headers}
                filename={file_name}
                separator={","}
                enclosingCharacter={`"`}
                className="btn btn-primary export-btn csvlink text-center"
                target="_blank"
                onClick={() => {
                  handleExportModalClose();
                }}
              >
                Download
              </CSVLink>
            )}
            <br />
            <p className="text-center" style={{ marginTop: "15px" }}>
              You can download recent most 500 record'(s)
            </p>
            {showLimitModal && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "18px" }}>
                  <b>Report count :</b> English :{en_count} Spanish: {es_count}{" "}
                  <b>Total</b>: {count}
                </span>
                <span
                  style={{
                    fontSize: "18px",
                    textAlign: "center",
                    marginTop: "10px",
                    color: "red",
                  }}
                >
                  Exceeds export limit of 500, refine your search
                </span>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => handleExportModalClose()}
            style={{
              cursor: "pointer",
              background: "red",
              border: "none",
              padding: "10px",
              color: "white",
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

MapTab.propTypes = {
  reports: PropTypes.array.isRequired,
  agency: PropTypes.object.isRequired,
  languageCode: PropTypes.string.isRequired,
};

export default MapTab;
